import React from 'react';
import Localization from 'es6/services/localization';
import FocusedPanel from 'es6/components/home/focused-panel';
import SavedPanel from 'es6/components/home/saved-panel';
import CustomPanel from 'es6/components/home/custom-panel';

export const StudyDetailsPanels = {
  FOCUSED: 'now-studying',
  SAVED: 'saved-courses',
  CUSTOM: 'custom-courses',
};

const StudyDetailsTabs = (props) =>
  <nav className="content-tabs study-details">
    <ul className="content-tabs-inner">
      {props.children}
    </ul>
  </nav>;
StudyDetailsTabs.propTypes = {
  children: React.PropTypes.node,
};

const StudyDetailsTab = (props) => {
  const onClick = props.onClick.bind(null, props.forPanel);
  let urgentSpan = null;

  if (props.urgent) {
    urgentSpan = (<span className="urgent"> ({props.urgent})</span>);
  }

  return (
    <li className="tab-container" onClick={onClick}>
      <div className={`content-tab ${props.selected ? 'selected' : ''}`}>
        {props.children}
        {urgentSpan}
      </div>
    </li>
  );
};
StudyDetailsTab.propTypes = {
  forPanel: React.PropTypes.oneOf(_.values(StudyDetailsPanels)).isRequired,
  onClick: React.PropTypes.func.isRequired,
  selected: React.PropTypes.bool,
  children: React.PropTypes.node,
  urgent: React.PropTypes.number,
};
StudyDetailsTab.defaultProps = {
  selected: false,
  urgent: 0,
};

export class StudyDetails extends React.Component {
  constructor(props) {
    super(props);
    this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
    this.handleTabClick = this.handleTabClick.bind(this);
    this.state = { panel: (this.props.panel ? this.props.panel : StudyDetailsPanels.FOCUSED) };
  }

  /**
   * Update the panel if the panel is passed in by the props.
   */
  componentWillReceiveProps(nextProps) {
    if (nextProps.panel !== null) {
      this.setState({ panel: nextProps.panel });
    }
  }

  handleTabClick(panel) {
    this.setState({ panel });

    if (this.props.onTabClick) {
      this.props.onTabClick.call(this, panel);
    }
  }

  render() {
    // Get urgency for focused and completed.
    const urgency = _.chain(this.props.aggregateMemories)
      .countBy(function (memory) {
        if (memory.focused && memory.items.isReadyToStudy()) {
          return 'ready';
        }

        return 'none';
      })
      .value();
    let onTabClick = this.handleTabClick;
    let focusedSelected = this.state.panel === StudyDetailsPanels.FOCUSED;
    let savedSelected = this.state.panel === StudyDetailsPanels.SAVED;
    let customSelected = this.state.panel === StudyDetailsPanels.CUSTOM;

    // Properties for all the panels. Custom panel will override goals.
    const panelProps = {
      aggregateMemories: this.props.aggregateMemories,
      goals: this.props.goals,
      onUnenroll: this.props.onUnenroll,
      onFocus: this.props.onFocus,
      onUnfocus: this.props.onUnfocus,
    };

    return (
      <div>
        <StudyDetailsTabs>
          <StudyDetailsTab forPanel={StudyDetailsPanels.FOCUSED} selected={focusedSelected} urgent={urgency.ready || 0} onClick={onTabClick}>
            {Localization.t('focused-courses')}
          </StudyDetailsTab>
          <StudyDetailsTab forPanel={StudyDetailsPanels.SAVED} selected={savedSelected} onClick={onTabClick}>
            {Localization.t('dashboard_tab.saved-courses')}
          </StudyDetailsTab>
          {
            this.props.isContentCreationEnabled && (
              <StudyDetailsTab forPanel={StudyDetailsPanels.CUSTOM} selected={customSelected} onClick={onTabClick}>
                {Localization.t('dashboard_tab.custom-courses')}
              </StudyDetailsTab>
            )
          }
        </StudyDetailsTabs>
        <section className="content-container study-details">
          <FocusedPanel selected={focusedSelected} {...panelProps} type={StudyDetailsPanels.FOCUSED} />
          <SavedPanel selected={savedSelected} {...panelProps} type={StudyDetailsPanels.SAVED} />
          {
            this.props.isContentCreationEnabled && (
              <CustomPanel selected={customSelected} {...panelProps} goals={this.props.customGoals} type={StudyDetailsPanels.CUSTOM} />
            )
          }
        </section>
      </div>
    );
  }
}
StudyDetails.propTypes = {
  aggregateMemories: React.PropTypes.object.isRequired,
  customGoals: React.PropTypes.array.isRequired,
  goals: React.PropTypes.array.isRequired,
  onUnenroll: React.PropTypes.func.isRequired,
  onFocus: React.PropTypes.func.isRequired,
  onUnfocus: React.PropTypes.func.isRequired,
  onTabClick: React.PropTypes.func.isRequired,
  panel: React.PropTypes.oneOf(_.values(StudyDetailsPanels)),
  isContentCreationEnabled: React.PropTypes.bool,
};
StudyDetails.defaultProps = {
  isContentCreationEnabled: true,
};
